import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import FeaturedProducts from './components/FeaturedProducts';
import VideoSection from './components/VideoSection';
import ImageCtaSection from './components/ImageCtaSection';
import FamilySection from './components/FamilySection';
import UnifiedDeviceList from './components/UnifiedDeviceList';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import DeviceModal from './components/DeviceModal';
import SimpleDeviceModal from './components/SimpleDeviceModal';
import PlatformModal from './components/PlatformModal';
import './App.css';

function App() {
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [selectedSimpleDevice, setSelectedSimpleDevice] = useState(null);
  const [isPlatformModalOpen, setIsPlatformModalOpen] = useState(false);

  return (
    <div className="App">
      <Header onOpenPlatformModal={() => setIsPlatformModalOpen(true)} />
      <Hero />
      <ImageCtaSection onOpenPlatformModal={() => setIsPlatformModalOpen(true)} />
      
      {/* Seção de Aparelhos em Destaque com Imagens */}
      <FeaturedProducts />
      
      {/* Seção de Vídeo e Monitoramento */}
      <VideoSection />
      
      {/* Catálogo Unificado - Destaques + Todos os Dispositivos */}
      {/* Seção de Família - Proteção e Segurança */}
      <FamilySection />
      
      <UnifiedDeviceList 
        onFeaturedClick={setSelectedDevice}
        onDeviceSelect={setSelectedSimpleDevice}
      />
      
      <ContactForm />
      <Footer />
      
      {/* Modal para dispositivos em destaque */}
      {selectedDevice && (
        <DeviceModal 
          device={selectedDevice} 
          onClose={() => setSelectedDevice(null)} 
        />
      )}
      
      {/* Modal para dispositivos do catálogo */}
      {selectedSimpleDevice && (
        <SimpleDeviceModal 
          device={selectedSimpleDevice} 
          onClose={() => setSelectedSimpleDevice(null)} 
        />
      )}

      {/* Modal de Seleção de Plataforma */}
      <PlatformModal 
        isOpen={isPlatformModalOpen}
        onClose={() => setIsPlatformModalOpen(false)}
      />
    </div>
  );
}

export default App;

